module.exports = __webpack_public_path__ + "static/media/W19-1581_2.50_Egger_2396x1473-desktop_en.463cc660.jpg";